import { useState } from 'react'
import { useSelector } from 'react-redux'

import Button from './Button'
import GridCircularProgress from './GridCircularProgress'
import { useRunAlgorithm } from '../hooks/algoritmi-functions'

const ButtonRunDownload = ({
  buttonText,
  algorithm,
  triggerDownload,
  type,
  disabled,
  preRun,
}) => {
  const selectedNumeriGara = useSelector(
    state => state.selection.selectedNumeriGara,
  )

  // disable condition (should be moved into components but it causes infinite loops)
  const disabledCondition =
    (algorithm === '09_GenerateExcelProvvedimenti' ||
      algorithm === '12_GenerateExcelDesignazioni') &&
    !selectedNumeriGara?.length

  const { runAlgorithm } = useRunAlgorithm()

  const [loading, setLoading] = useState()

  const isTxt = type === 'TXT'
  const isPdf = type === 'PDF'
  const isExcel = type === 'XLSX'

  return (
    <center>
      <Button
        disabled={disabled || loading || disabledCondition}
        txt={isTxt}
        pdf={isPdf}
        excel={isExcel}
        onClick={async () => {
          setLoading(true)
          if (preRun) {
            try {
              await preRun()
            } catch {
              setLoading()
              return
            }
          }
          await runAlgorithm({ algorithm, triggerDownload, type })
          setLoading()
        }}
      >
        {(loading && <GridCircularProgress color='inherit' size='1rem' />) ||
          buttonText}
      </Button>
    </center>
  )
}

export default ButtonRunDownload
